import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SectionHeader from './SectionHeader';
import { Reveal } from './ScrollReveal';
import { FiPlus } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const AccordionItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border-b border-brand-border last:border-b-0">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex justify-between items-center py-7 px-10 text-[1.1rem] font-serif text-brand-white hover:text-brand-gold transition-colors text-left" >
        {question}
        <motion.div animate={{ rotate: isOpen ? 45 : 0 }} className="text-brand-gold text-xl ml-6" >
          <SafeIcon icon={FiPlus} />
        </motion.div>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden bg-brand-surface" >
            <div className="px-10 pb-10 pt-2 text-[1rem] text-brand-muted leading-relaxed font-light" dangerouslySetInnerHTML={{ __html: answer }} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default function CaseStudies() {
  const cases = [
    { meta: "GF · Produktion · Österreich", quote: "„Ich hatte keinen, dem ich wirklich sagen konnte, was intern nicht funktioniert. Nach 6 Monaten im Kreis habe ich die Entscheidung getroffen, die ich 2 Jahre vor mir hergeschoben hatte.\"", start: "Stillstand bei Nachfolgeplanung, Konflikt im Führungsteam", end: "Führungsstruktur neu aufgestellt · Unternehmensbewertung +40 %" },
    { meta: "Gründer · SaaS · Deutschland", quote: "„Das Board Meeting war der erste Ort, wo ich offen über die Probleme mit meinem Co-Founder sprechen konnte — ohne Angst.\"", start: "15 Mitarbeiter, Führungsrolle ohne Vorbereitung", end: "Team auf 32 Mitarbeiter skaliert · Series-A erfolgreich abgeschlossen" },
    { meta: "Solopreneur · Beratung · Schweiz", quote: "„Zum ersten Mal hatte ich Menschen, die meine Situation wirklich verstehen — weil sie selbst alleine entscheiden.\"", start: "Umsatz-Plateau seit 2 Jahren, alle Entscheidungen allein", end: "Umsatz verdoppelt · erste Mitarbeiterin eingestellt" }
  ];

  const faqs = [
    { q: "Was kostet das Executive Sparring konkret?", a: "Der Einstieg ist ein <strong>kostenloses Probe-Board-Meeting</strong>. Die Sparring-Partnerschaft kostet <strong>€ 1.500 pro Monat</strong>. Kündigung ist jederzeit mit 4 Wochen Frist möglich." },
    { q: "Wie funktioniert die Garantie auf den Unternehmenswert genau?", a: "Ich garantiere die Verdoppelung Ihres Unternehmenswertes in <strong>maximal 36 Monaten</strong>. Ist das Ziel nach 36 Monaten nicht erreicht, arbeite ich <strong>kostenlos weiter</strong> bis zur Verdoppelung." },
    { q: "Was passiert, wenn ich im Board Meeting nicht offen reden will?", a: "Die Branchenregel macht genau das möglich: <strong>niemand im Kreis ist Ihr Konkurrent.</strong> Wer von Anfang an am zurückhaltendsten ist, redet meist am schnellsten am offensten." }
  ];

  return (
    <section id="ergebnisse" className="py-32 relative z-10 border-t border-brand-border">
      <div className="max-w-[1100px] mx-auto px-8">
        <SectionHeader 
          num="07" 
          eyebrow="Aus der Praxis" 
          title="Echte Gespräche.<br/><em class='not-italic italic text-brand-gold'>Echte Ergebnisse.</em>" 
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[1px] bg-brand-border border-2 border-brand-border mb-20 shadow-2xl">
          {cases.map((c, idx) => (
            <Reveal key={idx} delay={idx * 0.1}>
              <div className="bg-brand-dark p-12 h-full">
                <div className="text-[0.7rem] font-bold tracking-[0.2em] uppercase text-brand-gold mb-6">{c.meta}</div>
                <div className="font-serif text-[1.2rem] italic text-brand-white leading-relaxed mb-8">{c.quote}</div>
                <div className="text-[0.9rem] text-brand-muted leading-relaxed font-light">
                  <span className="text-brand-gold2 font-bold uppercase tracking-wider block mb-2">Ausgangslage:</span> {c.start}<br/>
                  <span className="text-brand-gold2 font-bold uppercase tracking-wider block mt-4 mb-2">Ergebnis:</span> {c.end}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <div className="mt-24 max-w-[900px] mx-auto">
            <div className="text-[0.75rem] font-bold tracking-[0.3em] uppercase text-brand-gold mb-10 text-center">Häufige Fragen — direkte Antworten</div>
            <div className="border-2 border-brand-border shadow-2xl">
              {faqs.map((faq, idx) => (
                <AccordionItem key={idx} question={faq.q} answer={faq.a} />
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}